import { FC } from 'react';
import { SpaceProps } from 'styled-system';
import { Money } from 'types';
import TotalLineItem from '../TotalLineItem';
import { Text } from '@qga/roo-ui/components';
import { FeesDisclaimer } from 'components/Disclaimers';

interface PayableAtPropertyProps extends SpaceProps {
  total: Money;
}

const PayableAtProperty: FC<PayableAtPropertyProps> = ({ total, ...rest }) => (
  <>
    <TotalLineItem title="Pay later at property" totals={[total]} pb={2} {...rest} />
    <Text fontSize="base" color="greys.dusty">
      Payable in local currency at check-in <FeesDisclaimer.Link />
    </Text>
  </>
);

export default PayableAtProperty;
